import Base64 from './base64';
import {addCookice, getCookie, deleteCookie} from './cookie';
import {parseDate,formatDate, changeDate, diffYearValue,isBetweenDate,firstDay,lastDay} from './date';
import jsonp from './jsonp';
import validator,{dictionary} from './validator';

export default {
	Base64,
	addCookice,
	getCookie,
	deleteCookie,
	parseDate,
	formatDate,
	changeDate,
	diffYearValue,
	isBetweenDate,
	firstDay,
	lastDay,
	jsonp,
	validator,
	dict: dictionary
};


// WEBPACK FOOTER //
// ./src/modules/utils/index.js